<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="value"
      persistent
      content
      content-class="centered-dialog"
    >
      <v-container fill-height>
        <v-layout column justify-center align-center>
          <AtomSpinner
            :animation-duration="1500"
            :size="60"
            :color="progressColor"
          />
          <h1 v-if="message !== null">{{ message }}</h1>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { i18n } from "@/services/vue-i18n";

export default {
  name: "Loader",
  components: {
    AtomSpinner
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      default: i18n.t("app.login.wait")
    },
    progressColor: {
      type: String,
      default: "#fff"
    }
  },
  data: function() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.dialog.centered-dialog {
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: whitesmoke;
}
</style>
